export default "__VITE_PUBLIC_ASSET__c6a6091a__"